import { useEffect, useState } from "react";
import { getAdminHeaders, toAssetUrl } from "./adminApi";

export default function AdminMemberMoments() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [approved, setApproved] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const pageSize = 20;

  const loadItems = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
      if (approved !== "") params.set("approved", approved);
      const res = await fetch(`/api/admin/moments?${params}`, { headers: getAdminHeaders() });
      const data = await res.json();
      if (res.ok) {
        setItems(data.items || []);
        setTotal(data.total || 0);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadItems();
  }, [page, approved]);

  const updateItem = async (item, patch) => {
    const res = await fetch(`/api/admin/moments/${item.id}`, {
      method: "PATCH",
      headers: getAdminHeaders(true),
      body: JSON.stringify(patch),
    });
    if (res.ok) {
      setMessage("已更新");
      loadItems();
    }
  };

  const remove = async (item) => {
    if (!window.confirm("删除这条动态？")) return;
    await fetch(`/api/admin/moments/${item.id}`, {
      method: "DELETE",
      headers: getAdminHeaders(),
    });
    setMessage("已删除");
    loadItems();
  };

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-800">会员动态管理</h1>
        <p className="text-sm text-gray-500 mt-1">审核、隐藏或删除会员发布的日常动态。</p>
      </div>

      {message && <div className="bg-green-50 text-green-700 text-sm px-4 py-2 rounded-lg">{message}</div>}

      <select
        value={approved}
        onChange={(e) => {
          setApproved(e.target.value);
          setPage(1);
        }}
        className="border rounded-lg px-3 py-2 text-sm"
      >
        <option value="">全部</option>
        <option value="1">已通过</option>
        <option value="0">待审核/已隐藏</option>
      </select>

      <div className="space-y-4">
        {loading ? (
          <p className="text-gray-400">加载中...</p>
        ) : items.length === 0 ? (
          <p className="text-gray-400">暂无动态</p>
        ) : (
          items.map((item) => (
            <div key={item.id} className="bg-white rounded-xl shadow p-4 space-y-2">
              <div className="flex justify-between text-sm">
                <span className="font-medium">
                  {item.author_name} · {item.author_city || "未知城市"}
                </span>
                <span className="text-gray-400 text-xs">{item.created_at?.slice(0, 16)}</span>
              </div>
              <p className="text-sm text-gray-700 whitespace-pre-line">{item.content}</p>
              {item.images?.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {item.images.map((url) => (
                    <img key={url} src={toAssetUrl(url)} alt="" className="w-16 h-16 object-cover rounded" />
                  ))}
                </div>
              )}
              <div className="flex flex-wrap gap-2 text-xs pt-2">
                <button
                  type="button"
                  onClick={() => updateItem(item, { is_approved: item.is_approved ? 0 : 1 })}
                  className="px-3 py-1 border rounded-lg"
                >
                  {item.is_approved ? "取消通过" : "通过展示"}
                </button>
                <button
                  type="button"
                  onClick={() => updateItem(item, { is_visible: item.is_visible ? 0 : 1 })}
                  className="px-3 py-1 border rounded-lg"
                >
                  {item.is_visible ? "隐藏" : "显示"}
                </button>
                <button type="button" onClick={() => remove(item)} className="px-3 py-1 text-red-500 border rounded-lg">
                  删除
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {totalPages > 1 && (
        <div className="flex justify-center gap-3">
          <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)} className="px-4 py-2 border rounded-lg text-sm">
            上一页
          </button>
          <span className="text-sm self-center">
            {page}/{totalPages}
          </span>
          <button
            disabled={page >= totalPages}
            onClick={() => setPage((p) => p + 1)}
            className="px-4 py-2 border rounded-lg text-sm"
          >
            下一页
          </button>
        </div>
      )}
    </div>
  );
}
